import { render, staticRenderFns } from "./doc_files.vue?vue&type=template&id=e28f6da8&scoped=true&"
import script from "./doc_files.vue?vue&type=script&lang=js&"
export * from "./doc_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f6da8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e28f6da8')) {
      api.createRecord('e28f6da8', component.options)
    } else {
      api.reload('e28f6da8', component.options)
    }
    module.hot.accept("./doc_files.vue?vue&type=template&id=e28f6da8&scoped=true&", function () {
      api.rerender('e28f6da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/doc/edit/tabs/doc_files.vue"
export default component.exports